import { Navbar } from 'react-bootstrap';

export type BrandProps = {
  onClick?: () => void;
  logoSrc?: string;
  logoAlt?: string;
  showText?: boolean;
  text?: string;
  clickable?: boolean;
};

export const Brand = ({
  onClick,
  logoSrc,
  logoAlt,
  showText = false,
  text = 'CAREMAPPR',
  clickable = false,
}: BrandProps) => {
  const className = ['flexHorizCentered', clickable ? 'clickable' : null]
    .filter(Boolean)
    .join(' ');

  return (
    <Navbar.Brand
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >
      <div id="brand-box" className={className}>
        <img id="brandImage" src={logoSrc} alt={logoAlt || 'logo'} />
        {showText ? <div id="caremappr">{text}</div> : null}
      </div>
    </Navbar.Brand>
  );
};
